import { render } from "./PaymentBox.vue?vue&type=template&id=e282d4b2"
import script from "./PaymentBox.vue?vue&type=script&lang=js"
export * from "./PaymentBox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/david/Desktop/projects/ConexionCreativa/real-gestion/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__